import React from 'react';
import { spacing } from '../design-system/tokens';

interface GridLayoutProps {
  children: React.ReactNode;
  className?: string;
  columns?: string;
  gap?: keyof typeof spacing;
  rowGap?: keyof typeof spacing;
  style?: React.CSSProperties;
}

export const GridLayout: React.FC<GridLayoutProps> = ({ 
  children,
  className = '',
  columns = 'repeat(auto-fit, minmax(280px, 1fr))',
  gap = '2xl',
  rowGap = 'xl',
  style = {}
}) => {
  // Use Figma spacing by default for consistency
  const defaultGap = spacing.figma.sectionGap;
  const defaultRowGap = spacing.figma.sectionGap;
  
  return (
    <div 
      className={className}
      style={{ 
        display: 'grid',
        gridTemplateColumns: columns,
        gap: defaultGap,
        rowGap: defaultRowGap,
        ...style
      }}
    >
      {children}
    </div>
  );
};